import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams, useNavigate } from 'react-router-dom';
import AuthService from "services/auth.service";
import {   
  Row,
  Col,
} from "reactstrap";

const ViewTransactionList = () => {
    const { id }= useParams();
  const [transaction, setTransaction] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchEmail, setSearchEmail] = useState("");

  useEffect(() => {
    retrieveTransaction();
  }, []);

  // const onChangeSearchEmail = e => {
  //   const searchEmail = e.target.value;
  //   setSearchEmail(searchEmail);
  // };

  const retrieveTransaction = () => {
    AuthService.getAllTransaction(id)
      .then(response => {
        setTransaction(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const refreshList = () => {
    retrieveTransaction();
    setCurrentUser(null);
    setCurrentIndex(-1);
  };

  const setActiveUser = (user, index) => {
    setCurrentUser(user);
    setCurrentIndex(index);
    
  };


  const removeAllTutorials = () => {
    AuthService.removeAll()
      .then(response => {
        console.log(response.data);
        refreshList();
      })
      .catch(e => {
        console.log(e);
      });
  };

  const findByTitle = () => {
    AuthService.findByTitle(searchEmail)
      .then(response => {
        setTransaction(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  
  
  return (
    <div className="content">
        <Row>
          <Col>
    <div className="list row">
      <div className="col-md-8">
        {/* <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by email"
            value={searchEmail}
            onChange={onChangeSearchEmail}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={findByTitle}
            >
              Search
            </button>
          </div>
        </div> */}
      </div>
      <div className="col-md-6 admin-visible">
        <h4>Transaction List</h4>

        <ul className="list-group">
          {transaction &&
            transaction.map((user, index) => (
              <li
                className={
                  "list-group-item " + (index === currentIndex ? "active" : "")
                }
                onClick={() => setActiveUser(user, index)}
                key={index}
              >
                {user.title}
              </li>
            ))}
        </ul>

        {/* <button
          className="m-3 btn btn-sm btn-danger"
          onClick={removeAllTutorials}
        >
          Remove All
        </button> */}
      </div>
      <div className="col-md-6">
        {currentUser ? (
          <div className="admin-visible">
            <h4>transaction Detail</h4>
            <div>
              <label>
                <strong>Total Fee Cost</strong>
              </label>{" $"}
              {currentUser.totalFee} 
            </div>
            <div>
              <label>
                <strong>Refundable Fee:</strong>
              </label>{" $"} 
              {currentUser.refundableFee}
            </div>
            
            <div>
              <label>
                <strong>Status:</strong>
              </label>{" "}
              {currentUser.status ? "Paid" : "Pending"}
            </div>

            <Link
              to={"/admin/transaction/" + currentUser.id+ "/edit"}
              className="badge badge-warning"
            >
              Edit
            </Link>
            
           
          </div>
        ) : (
          <div>
            <br />
            <p className="admin-visible">Please click on a transaction...</p>
          </div>
        )}
      </div>
    </div>
    </Col>
    </Row>
    </div>
  );
};

export default ViewTransactionList;